import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTopNavbar } from "../../Reducers/actions/navbarActions";
import { getPaginatedPayments } from "../../Reducers/actions/paymentActions";
import { PaymentSummaryRowSkeleton } from "../../components/Skeletons/FinanceListSkeletons";


import "./EarningHistoryList.scss"
import PaymentSummary from "../PaymentHistory/PaymentSummary";
import { tabs } from "./Earnings";
import Icon from "../../components/Icon";
import { setActiveTab } from "../../Reducers/actions/earningActions";

const tabNames = {
    purchase_digital: "digital sales",
    purchase_physical: "physical sales",
    contribution: "contributions",
    monthly_contribution: "monthly contribution",
    all: "earnings"
};

function EarningHistoryList() {
    const dispatch = useDispatch();

    const { auth_user_id, activeTab, payments, paymentsLoading } = useSelector((state) => ({
        paymentsLoading: state?.payments?.loading,
        payments: state?.payments?.payments,
        activeTab: state?.earnings?.activeTab,
        auth_user_id: state.auth.user?.user_id,
    }));
    const filteredPayments = payments.filter(payment => {
        if (activeTab === 'all') return true;
        return payment.type === activeTab
    })

    const getTabLabels = (tab) => tabNames[tab] || tab;



    useEffect(() => {
        if (!auth_user_id) return;
        dispatch(getPaginatedPayments(0, 10, null, false, true));
        dispatch(setTopNavbar({ showBackArrow: true, title: "All Earnings" }));

    }, [auth_user_id]);

    const handleSetActiveTab = (tab) => {
        dispatch(setActiveTab(tab));
    };
    return (
        <div className="mt-24 earning-list-container">
            <div className="tabsa d-flex f-row jcc ais ">
                {tabs.map((tab) => (
                    (tab.tab === "all") ?
                        <div
                            className={`tabearning ${activeTab === tab.tab ? ' active' : ''}`}
                            key={tab.tab}
                            onClick={() => handleSetActiveTab(tab.tab)}
                        >{tab.tab}</div> :
                        <div className={`tabearningicon ${activeTab === tab.tab ? ' active' : ''}`}
                        >
                            <Icon
                                key={tab.tab}
                                alias={tab.icon}
                                onClick={() => handleSetActiveTab(tab.tab)}
                                color={activeTab === tab.tab ? "#FF3232" : "#0A0F1E"}
                                height={56}
                                style={{ paddingLeft: "16px" }}
                            /></div>
                ))}
            </div>

            <div className="transactions-container px-16 pb-24">

                {paymentsLoading ? (
                    <>
                        {[1, 2, 3, 4, 5].map((i) => (
                            <PaymentSummaryRowSkeleton key={i} />
                        ))}
                    </>
                ) : filteredPayments.length == 0 ? (<div className="d-flex f-column aic jcc mt-50 ">
                    <p className="fs-xs fg-dark fw-bold mt-40">No {getTabLabels(activeTab)} yet</p>
                    <p className="fg-grey7 fs-xs fw-medium">Your earnings from {getTabLabels(activeTab)} will appear here</p>
                </div>) : (
                    filteredPayments?.map((payment) => <PaymentSummary payment={payment} />)
                )}
            </div>
        </div>
    );
}

export default EarningHistoryList;
